<template>
  <div class="p-4 bg-charcoal text-white">
    <h1 class="text-2xl">Error Details</h1>
    <ul class="whitespace-pre-wrap font-mono text-xs">
      <li><strong>url:</strong> {{ error.url }}</li>
      <li><strong>statusCode:</strong> {{ error.statusCode }}</li>
      <li><strong>statusMessage:</strong> {{ error.statusMessage }}</li>
      <li><strong>message:</strong> {{ error.message }}</li>
    </ul>
    <u-divider class="my-4" />
    <h2 class="text-2xl">Stack Trace</h2>
    <div v-html="error.stack" class="text-xs" />
  </div>
</template>

<script setup>
  const props = defineProps({
    error: Object
  });
</script>
